import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 48 * 60 * 60 * 1000, // 48 hours for garbage collection (formerly cacheTime)
      retry: 2,
    },
  },
});

if (typeof window !== "undefined") {
  try {
    window.localStorage.removeItem("REACT_QUERY_OFFLINE_CACHE");
  } catch (error) {
    console.warn("Could not clear the legacy persisted query cache:", error);
  }
}

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </HelmetProvider>
    </React.StrictMode>,
  );
}
